<ng-container *ngIf="permissions.view_virtual_weight && feeder">
  <div class="d-flex w-100 px-3 pb-3">
    <b>{{ "content-device-virtual-weight.food-in-hopper" | translate }}</b>
  </div>
  <div class="row justify-content-center animated animate__fadeIn w-100 m-0">
    <!-- <div class="col-12 col-lg-6 center">
      <div class="center flex-column">
        <app-virtual-weight
          *ngIf="feeder.virtual_weight"
          [percent]="
                feeder.virtual_weight.percentage
                  ? feeder.virtual_weight.percentage
                  : 0
              "
          [width]="150"
          [height]="150"
          [feeder]="feeder"
          (onClick)="onClickVirtualWeight($event)"
        ></app-virtual-weight>
        <div class="mt-3">
          <h4 class="m-0">
            {{ feeder.virtual_weight && feeder.virtual_weight.left_kgs ? feeder.virtual_weight.left_kgs :
            '0'}} Kg.
          </h4>
          Báscula
        </div>
      </div>
    </div> -->
    <div class="col-12 col-lg-6 center">
      <div class="center flex-column">
        <app-virtual-weight
          *ngIf="feeder.virtual_weight"
          [percent]="
                feeder.virtual_weight.percentage
                  ? feeder.virtual_weight.percentage
                  : 0
              "
          [width]="150"
          [height]="150"
          [feeder]="feeder"
          (onClick)="onClickVirtualWeight($event)"
        ></app-virtual-weight>
        <div class="mt-3">
          <h4 class="m-0">
            {{ feeder.virtual_weight && feeder.virtual_weight.left_kgs ?
            feeder.virtual_weight.left_kgs : '0'}} Kg.
          </h4>
          {{ "comparation-weight-sensor.digital" | translate }}
        </div>
      </div>
    </div>
    <div class="col-12 text-center mt-3">
      <p
        [ngbTooltip]="
          (
            (feeder.virtual_weight && feeder.virtual_weight.target_kgs
              ? feeder.virtual_weight.target_kgs
              : 0) -
            (feeder.virtual_weight && feeder.virtual_weight.left_kgs
              ? feeder.virtual_weight.left_kgs
              : 0)
          ) + 'kg'
        "
      >
        {{ "comparation-weight-sensor.food-distributed" | translate }}
        {{
          (
            (feeder.virtual_weight && feeder.virtual_weight.target_kgs
              ? feeder.virtual_weight.target_kgs
              : 0) -
            (feeder.virtual_weight && feeder.virtual_weight.left_kgs
              ? feeder.virtual_weight.left_kgs
              : 0)
          ) | number:"1.2-2"
        }}kg
      </p>
    </div>
  </div>
</ng-container>
